import { DrawerStore, OrdersStore, PlaceStore } from ".";
import { RootStoreInterface } from "../interfaces_and_types";
import { create } from 'mobx-persist'

const hydrate = create({
  storage: localStorage,
  jsonify: true
})

export class RootStore implements RootStoreInterface{
  orderStore;
  placeStore;
  drawerStore;

  constructor() {
    this.orderStore = new OrdersStore()
    this.placeStore = new PlaceStore()
    this.drawerStore = new DrawerStore()
    hydrate('placeStore', this.placeStore)
  }
}

const rootStore = new RootStore();
export default rootStore;
